import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Isvg from 'react-inlinesvg';
import { DESIGN_SYSTEM_ICONS } from 'constants/icons';
import css from './Favorites.scss';

export const Favorites = ({ highlighted, label, ...rest }) => (
  <li
    className={cx(css.base, {
      [css.isHighlighted]: highlighted,
    })}
    {...rest}>
    <div className={css.link} data-qa="Favorites.link">
      <Isvg className={css.icon} data-qa="Favorites.icon" src={DESIGN_SYSTEM_ICONS.heartFilled} />
      <div className={css.content} data-qa="Favorites.content">
        <span className={css.label} data-qa="Favorites.label">
          {label}
        </span>
      </div>
    </div>
  </li>
);

Favorites.propTypes = {
  highlighted: PropTypes.bool.isRequired,
  label: PropTypes.object.isRequired,
};
